import getCropper from '../libs/customCropper'

// Cropper instance.
let cropper

// Modal jQuery object.
let modal

// Sizes config
let sizes = {}

const callbacks = {
    avatar: () => {
        if (!cropper) {
            return false
        }
        spinner.show();
        const form = $('form', modal);
        let formData = new FormData();
        cropper.getCroppedCanvas(sizes.crop).toBlob(blob => {
            formData.append('image', blob);
            formData.append('file', 'image')
            $.ajax({
                url: '/site/users/update-avatar',
                data: formData,
                processData: false,
                contentType: false,
                type: 'post'
            })
                .done(() => reload_window())
                .fail(() => spinner.remove());
        })
    }, communityDesktop: () => {
        communityImageUploadCallback('cover').then(() => reload_window(), () => spinner.remove())
        return false
    }, communityMobile: () => {
        communityImageUploadCallback('mobile_cover').then(() => reload_window(), () => spinner.remove())
        return false
    }, communityLogo: () => {
        communityImageUploadCallback('logo').then(() => reload_window(), () => spinner.remove())
        return false
    },
    avatarLogo: function () {
        communityImageUploadCallback('avatar_logo').then(() => reload_window(), () => spinner.remove())
        return false
    },

}

const communityImageUploadCallback = field => {
    return new Promise((resolve, reject) => {
        if (cropper) {
            const form = $('form', modal);
            let formData = new FormData();
            cropper.getCroppedCanvas(sizes.crop).toBlob(blob => {
                formData.append('image', blob)
                formData.append('cid', cid)
                formData.append('file', 'image')
                formData.append('field', field)
                spinner.show()
                $.ajax({
                    url: '/site/communities/update-image',
                    data: formData,
                    processData: false,
                    contentType: false,
                    type: 'post'
                })
                    .done(resolve)
                    .fail(reject);
            })
        } else {
            reject()
        }
    })
}

/**
 *
 * @param file File
 *   File field to load from.
 * @returns {Promise<string>}
 *   Image content
 */
const loadImage = file => {
    return new Promise((resolve, reject) => {
        if (!window.FileReader) {
            reject('No file selected');
        }
        if (/^image/.test(file.type)) {
            const reader = new FileReader();
            spinner.show('')
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                spinner.remove()
                resolve(this.result)
            }
        } else {
            reject('Not an image')
        }
    })
}

const initCropper = (target, sizes) => {
    const slider = modal.find('.slider:not(.has-slider)')
    if (target.length > 0) {
        if (!cropper) {
            cropper = getCropper(target[0], sizes.cropperRatio || 1);
            const resetBtn = modal.find('.btn-reset');
            const rotateBtn = modal.find('.btn-rotate');
            if (slider.length > 0) {
                cropper.attachSlider(slider, modal.find('.btn-plus'), modal.find('.btn-minus'));
                if (resetBtn.length > 0) {
                    cropper.attachResetButton(resetBtn);
                }
                if (rotateBtn.length > 0) {
                    cropper.attachRotateButton(rotateBtn);
                }
                slider.addClass('has-slider');
            }
        } else {
            cropper.replace(target[0].src)
        }
    }
}

const destroyCropper = () => {
    if (cropper) {
        cropper.destroy();
        cropper = null;
    }
}

const showModal = () => {
    return new Promise(resolve => {
        modal.on('hidden.bs.modal', destroyCropper);
        modal.on('hidden.bs.modal', () => {
            if ($('.modal:visible').length > 0 && !$('body').hasClass('modal-open')) {
                $('body').addClass('modal-open');
            }
        });
        if (modal.is(':visible')) {
            resolve();
        } else {
            modal.one('shown.bs.modal', resolve)
            modal.modal('show')
        }
    })
}

$(() => {
    modal = $('#editImage');
    if (modal.length > 0) {
        const uploadFile = $('input[type="file"]', modal);
        const container = modal.find('.image-preview');
        const target = container.find('img');

        window.addEventListener('resize', function (data) {
            container.height(Math.ceil(container.width() / (sizes.containerRatio || 1)))
        })

        uploadFile.on('change', async function () {
            try {
                let files = !!this.files ? this.files : [];
                if (files.length === 0) {
                    return
                }
                let file = await loadImage(files[0])

                if (file) {
                    await showModal()
                    target.attr('src', file);
                    if (!cropper) {
                        // Init container height
                        container.height(Math.ceil(container.width() / (sizes.containerRatio || 1)))
                    }
                    initCropper(target, sizes);
                }
            } catch (msg) {
                console.log(msg)
            }
        })

        $('[data-action="file"]', modal).on('click', function () {
            uploadFile.val('')
            uploadFile.trigger('click')
            return false
        })

        const editGivenFile = async function(f) {
            const file = await loadImage(f)
            await showModal()
            target.attr('src', file);
            if (!cropper) {
                // Init container height
                container.height(Math.ceil(container.width() / (sizes.containerRatio || 1)))
            }
            initCropper(target, sizes);
        }

        window.editCover = function (options) {
            sizes = window.sizes[options.type]
            const modalSize = options.modalSize || ''
            const modalTitle = options.title || ''
            const m = $('.modal-dialog', modal)
            if (modalSize.length) {
                m.removeClass(['modal-lg', 'modal-sm', 'modal-xs', 'modal-md']);
                m.addClass('modal-' + modalSize)
            }
            if (modalTitle.length) {
                m.find('.modal-header').html(modalTitle)
            }
            const callback = options.submit || callbacks[options.callbackName] || callbacks[options.type] || (() => console.error('No callback'))

            $('[data-action="submit"]', modal)
                .off('click.editimage')
                .on('click.editimage', e => { return callback(modal, cropper) })

            if (options.file) {
                editGivenFile(options.file)
            } else {
                uploadFile.val('')
                uploadFile.trigger('click')
            }
        }
    } else {
        window.editCover = () => { }
    }
})
